    <div class="row no-gutters content_top_margin">
        <div class="col-12">
            <form>
                <fieldset role="radiogroup" aria-required="true">
                    <legend class="legend_display bot_spa_aft_sect_heading sectionHeading_one" id="timeHorizon">{{
                        'time-horizon.title' | translate }}</legend>
                    <div class="row no-gutters bot_spa_aft_sect_heading">
                        <div class="col-12">
                            <label class="d-flex align-items-center field_lable_bot_margin_unset">
                                <div [ngClass]=" (selectionY) ? 'cst-rd-check':'cst-rd'">
                                    <input aria-required="true" id="yes" [attr.aria-checked]="selectionY"
                                        aria-describedby="valMessage" class="radioPosition" type="radio"
                                        name="time-to-purchase" [checked]="selectionY" (click)="buttonDisplay('yes')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span [ngClass]="{'errorColor':validation}" class="ml-2">
                                    {{ 'time-horizon.opt1' | translate }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-12">
                            <label class="d-flex align-items-center field_lable_bot_margin_unset">
                                <div [ngClass]="(selectionN) ? 'cst-rd-check':'cst-rd'">
                                    <input aria-required="true" id="no" [attr.aria-checked]="selectionN"
                                        aria-describedby="valMessage" class="radioPosition" type="radio"
                                        name="time-to-purchase" [checked]="selectionN" (click)="buttonDisplay('no')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span [ngClass]="{'errorColor':validation}" class="ml-2">
                                    {{ 'time-horizon.opt2' | translate }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div *ngIf="validation">
                        <img src="./assets/images/menu_icons/Alert.svg" alt="">
                        <span id="valMessage"> {{ 'time-horizon.valid' | translate }}</span>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
    <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
        <div class="col-12 d-flex flex-column-reverse d-md-block">
            <cancel-button></cancel-button>
            <button type="button" class="common_btn saveNextBtn_features space_between_button"
                (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
        </div>
    </div>
